import { Token } from '@ubeswap/sdk-core'

export class UserAddedToken extends Token {}
